document.addEventListener('DOMContentLoaded', function () {
    if (window.location.href.includes('/collections/all')) {
        const collectionTitle = document.querySelector('.m-collection-page-header__title');
        
        if (collectionTitle) {
            collectionTitle.textContent = 'Productos';
        }
    }
});